import axios from "axios";
import HostService from "../../../services/host.service";
import AuthService from "../../../services/auth.service";
import { ORDER_STATE } from "../../../config/constants";

/**
 * Servicio para operaciones de ventas del feature "ordenes"
 */
class VentasService {
    /**
     * Avisar al personal de almacén de que hay pedidos pendientes de preparar.
     * Envía una notificación push a todos los usuarios con rol almacen.
     * No comprueba si existen pedidos pendientes ni limita la frecuencia: cada
     * llamada reparte un aviso.
     * @returns {Promise<{avisados: number}>} Usuarios de almacén avisados
     */
    static async avisarPreparacion() {
        const response = await axios.post(
            HostService.getHost() + 'ventas/avisar-preparacion',
            {},
            AuthService.setToken()
        );
        return response.data.data;
    }

    /**
     * Forzar como preparado un pedido colgado de Nave 2, para sacarlo del listado.
     * Con `forzado` el backend no avisa al preparador de Nave 1: nadie lo ha punteado
     * en Nave 2 y el aviso "ya está preparado" sería falso.
     * @param {string} numero - Documento en formato "SERIE-NUMERO"
     * @param {number} ejercicio - Año del ejercicio
     * @param {string} tipo - Tipo de documento (albaran|pedido, el backend lo normaliza)
     * @returns {Promise<Object>} Registro de Nave 2 resultante
     */
    static async forzarPreparadoN2(numero, ejercicio, tipo) {
        const response = await axios.post(
            HostService.getHost() + 'ventas/n2/asignar',
            { estado: ORDER_STATE.PREPARADO, forzado: true },
            { ...AuthService.setToken(), params: { pedido: numero, ejercicio, tipo } }
        );
        return response.data.data;
    }

    /**
     * Últimos pedidos/albaranes marcados como preparados en Nave 2, del más reciente
     * al más antiguo.
     * @param {number} ejercicio - Año del ejercicio
     * @param {number} [limite=50] - Número máximo de pedidos a devolver (1-200)
     * @returns {Promise<Array<{numero: string, tipo: string, preparado: (string|null),
     *   registrado: string, cliente: (string|null), ruta: (string|null)}>>} Pedidos preparados
     */
    static async getPreparadosN2(ejercicio, limite = 50) {
        const response = await axios.get(
            HostService.getHost() + 'ventas/n2/preparados',
            { ...AuthService.setToken(), params: { ejercicio, limite } }
        );
        return response.data.data;
    }
}

export default VentasService;
